import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const GuestSelfCheckin = lazy(() => import("@/pages/GuestSelfCheckin"));

export const Route = createFileRoute("/checkin/$eventId")({
  component: GuestSelfCheckin,
});
